import { API } from "./index";
import { get, post, put, remove } from "../net";
import qs from "querystring";

class BookKeepingService {
    async getBookKeepingLinks(userId) {
        let request = get({
            endpoint:  `bookKeepingLinks?${qs.stringify({ userId })}`,
            watcher: this.watcher
        });
        try {
            let { error, payload } = await request;
            return API.handleResponse(request, payload, error);
        } catch(ex) {
            return API.error(request, ex);
        }
    }

    async deleteBookKeepingLink(bookKeepingLinkId) {
        let request = remove({
            endpoint:  `bookKeepingLinks/${bookKeepingLinkId}`,
            watcher: this.watcher
        });
        try {
            let { error, payload } = await request;
            return API.handleResponse(request, payload, error);
        } catch(ex) {
            return API.error(request, ex);
        }
    }

    async createBookKeepingLink(data) {
        let request = post({
            endpoint:  `addbookKeepingLinks`,
            data,
            watcher: this.watcher
        });
        try {
            let { error, payload } = await request;
            return API.handleResponse(request, payload, error);
        } catch(ex) {
            return API.error(request, ex);
        }
    }

    async updateBookKeepingLink(data) {
        let request = put({
            endpoint:  `bookKeepingLink/update`,
            data,
            watcher: this.watcher
        });
        try {
            let { error, payload } = await request;
            return API.handleResponse(request, payload, error);
        } catch(ex) {
            return API.error(request, ex);
        }
    }
}

export default new BookKeepingService();